// UX55: topic subscriptions.
//
// Per-pubkey set of followed topics, stored locally. Same storage
// shape as jurisdictionByPubkey (UX49): one LS key with a map keyed
// by pubkey → string[] of subscribed topic labels (lowercased).
//
// Topics are compared case-insensitively because the bot event tags
// use varying casing ("Government Operations" vs "government operations").

const LS_TOPIC_SUBS = 'verdant_topic_subs_by_pubkey'

function loadMap() {
  try {
    const raw = localStorage.getItem(LS_TOPIC_SUBS)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

function saveMap(map) {
  try {
    localStorage.setItem(LS_TOPIC_SUBS, JSON.stringify(map))
  } catch { /* quota — noop */ }
}

export function loadTopicSubs(pubkey) {
  if (!pubkey) return []
  const map = loadMap()
  const subs = map[pubkey]
  return Array.isArray(subs) ? subs : []
}

export function toggleTopicSub(pubkey, topic) {
  if (!pubkey || !topic) return loadTopicSubs(pubkey)
  const key = topic.toLowerCase()
  const map = loadMap()
  const current = Array.isArray(map[pubkey]) ? map[pubkey] : []
  const next = current.includes(key)
    ? current.filter((t) => t !== key)
    : [...current, key]
  if (next.length === 0) delete map[pubkey]
  else map[pubkey] = next
  saveMap(map)
  return next
}

export function isSubscribed(subs, topic) {
  if (!Array.isArray(subs) || !topic) return false
  return subs.includes(topic.toLowerCase())
}
